import api from './api';

// =====================================================
// TYPES - Páginas
// =====================================================

export interface CMSPage {
  id: number;
  slug: string;
  titulo: string;
  meta_descricao?: string;
  meta_keywords?: string;
  status: 'rascunho' | 'publicado';
  created_at?: string;
  updated_at?: string;
  total_features?: number;
  total_faq?: number;
}

export interface CMSPageInput {
  slug: string;
  titulo: string;
  meta_descricao?: string;
  meta_keywords?: string;
  status?: 'rascunho' | 'publicado';
}

// =====================================================
// TYPES - Hero
// =====================================================

export interface CMSHero {
  id: number;
  pagina_id: number;
  badge_texto?: string;
  titulo: string;
  subtitulo?: string;
  descricao?: string;
  btn_primario_texto?: string;
  btn_primario_link?: string;
  btn_primario_icone?: string;
  btn_secundario_texto?: string;
  btn_secundario_link?: string;
  btn_secundario_icone?: string;
  trust_badge_texto?: string;
  trust_badge_rating?: number;
  imagem_fundo?: string;
  status: 'ativo' | 'inativo';
}

export interface CMSHeroInput {
  badge_texto?: string;
  titulo: string;
  subtitulo?: string;
  descricao?: string;
  btn_primario_texto?: string;
  btn_primario_link?: string;
  btn_primario_icone?: string;
  btn_secundario_texto?: string;
  btn_secundario_link?: string;
  btn_secundario_icone?: string;
  trust_badge_texto?: string;
  trust_badge_rating?: number;
  imagem_fundo?: string;
  status?: 'ativo' | 'inativo';
}

// =====================================================
// TYPES - Features
// =====================================================

export interface CMSFeature {
  id: number;
  pagina_id: number;
  icone: string;
  titulo: string;
  descricao?: string;
  link?: string;
  cor_fundo?: string;
  cor_texto?: string;
  ordem: number;
  status: 'ativo' | 'inativo';
}

export interface CMSFeatureInput {
  icone: string;
  titulo: string;
  descricao?: string;
  link?: string;
  cor_fundo?: string;
  cor_texto?: string;
  ordem?: number;
  status?: 'ativo' | 'inativo';
}

// =====================================================
// TYPES - Planos/Preços
// =====================================================

export interface CMSPlanFeature {
  id: number;
  plano_id: number;
  texto: string;
  incluido: boolean;
  ordem: number;
}

export interface CMSPlan {
  id: number;
  pagina_id: number;
  nome: string;
  subtitulo?: string;
  preco?: number;
  moeda?: string;
  intervalo?: string;
  badge?: string;
  btn_texto?: string;
  btn_link?: string;
  destaque: boolean;
  ordem: number;
  status: 'ativo' | 'inativo';
  features?: CMSPlanFeature[];
}

export interface CMSPlanInput {
  nome: string;
  subtitulo?: string;
  preco?: number;
  moeda?: string;
  intervalo?: string;
  badge?: string;
  btn_texto?: string;
  btn_link?: string;
  destaque?: boolean;
  ordem?: number;
  status?: 'ativo' | 'inativo';
  features?: { texto: string; incluido?: boolean }[];
}

// =====================================================
// TYPES - Testemunhos
// =====================================================

export interface CMSTestimonial {
  id: number;
  pagina_id?: number;
  pagina_titulo?: string;
  citacao: string;
  autor_nome: string;
  autor_cargo?: string;
  autor_empresa?: string;
  autor_avatar?: string;
  avaliacao: number;
  ordem: number;
  status: 'ativo' | 'inativo';
}

export interface CMSTestimonialInput {
  pagina_id?: number;
  citacao: string;
  autor_nome: string;
  autor_cargo?: string;
  autor_empresa?: string;
  autor_avatar?: string;
  avaliacao?: number;
  ordem?: number;
  status?: 'ativo' | 'inativo';
}

// =====================================================
// TYPES - Parceiros (logótipos da landing)
// =====================================================

export interface CMSParceiro {
  id: number;
  nome: string;
  logo_url: string;
  website_url?: string;
  descricao?: string;
  ordem: number;
  status: 'ativo' | 'inativo';
}

export interface CMSParceiroInput {
  nome: string;
  logo_url: string;
  website_url?: string;
  descricao?: string;
  ordem?: number;
  status?: 'ativo' | 'inativo';
}

// =====================================================
// TYPES - FAQ
// =====================================================

export interface CMSFAQ {
  id: number;
  pagina_id?: number;
  pagina_titulo?: string;
  categoria?: string;
  pergunta: string;
  resposta: string;
  ordem: number;
  status: 'ativo' | 'inativo';
}

export interface CMSFAQInput {
  pagina_id?: number;
  categoria?: string;
  pergunta: string;
  resposta: string;
  ordem?: number;
  status?: 'ativo' | 'inativo';
}

// =====================================================
// TYPES - CTA
// =====================================================

export interface CMSCTA {
  id: number;
  pagina_id: number;
  posicao?: string;
  titulo: string;
  descricao?: string;
  btn_texto?: string;
  btn_link?: string;
  cor_fundo?: string;
  ordem: number;
  status: 'ativo' | 'inativo';
}

export interface CMSCTAInput {
  posicao?: string;
  titulo: string;
  descricao?: string;
  btn_texto?: string;
  btn_link?: string;
  cor_fundo?: string;
  ordem?: number;
  status?: 'ativo' | 'inativo';
}

// =====================================================
// TYPES - Blog
// =====================================================

export interface CMSBlogCategory {
  id: number;
  slug: string;
  nome: string;
  descricao?: string;
  cor?: string;
  ordem: number;
  status: 'ativo' | 'inativo';
  total_artigos?: number;
}

export interface CMSBlogAuthor {
  id: number;
  nome: string;
  cargo?: string;
  bio?: string;
  avatar?: string;
  email?: string;
  linkedin?: string;
  twitter?: string;
  status: 'ativo' | 'inativo';
  total_artigos?: number;
}

export interface CMSBlogPost {
  id: number;
  slug: string;
  titulo: string;
  resumo?: string;
  conteudo?: string;
  categoria_id?: number;
  categoria_nome?: string;
  autor_id?: number;
  autor_nome?: string;
  imagem_destaque?: string;
  tempo_leitura: number;
  destaque: boolean;
  tags?: string;
  meta_descricao?: string;
  visualizacoes: number;
  data_publicacao?: string;
  status: 'rascunho' | 'publicado' | 'arquivado';
  created_at?: string;
  updated_at?: string;
}

export interface CMSBlogPostInput {
  slug: string;
  titulo: string;
  resumo?: string;
  conteudo?: string;
  categoria_id?: number;
  autor_id?: number;
  imagem_destaque?: string;
  tempo_leitura?: number;
  destaque?: boolean;
  tags?: string;
  meta_descricao?: string;
  status?: 'rascunho' | 'publicado' | 'arquivado';
  data_publicacao?: string;
}

// =====================================================
// TYPES - Footer
// =====================================================

export interface CMSFooterLink {
  id: number;
  coluna_id: number;
  texto: string;
  url: string;
  badge?: string;
  externo: boolean;
  ordem: number;
}

export interface CMSFooterColumn {
  id: number;
  titulo: string;
  ordem: number;
  links?: CMSFooterLink[];
}

export interface CMSFooterSocial {
  id: number;
  rede: string;
  url: string;
  icone?: string;
  ordem: number;
}

export interface CMSFooter {
  id?: number;
  descricao_empresa?: string;
  copyright_texto?: string;
  colunas: CMSFooterColumn[];
  social: CMSFooterSocial[];
}

// =====================================================
// TYPES - Config
// =====================================================

export interface CMSMedia {
  id: number;
  nome: string;
  tipo: string;
  url: string;
  tamanho?: number;
  largura?: number;
  altura?: number;
  alt_text?: string;
  pasta: string;
  created_at?: string;
}

export interface CMSConfig {
  id: number;
  chave: string;
  valor?: string;
  valor_en?: string;
  valor_fr?: string;
  tipo: string;
  descricao?: string;
}

// =====================================================
// TYPES - Response
// =====================================================

export interface CMSResponse<T> {
  success: boolean;
  data: T;
  error?: string;
}

export interface CMSListResponse<T> {
  success: boolean;
  data: T[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  error?: string;
}

// =====================================================
// SERVICE
// =====================================================

const cmsService = {
  // ===== PÁGINAS =====
  getPages: () => api.get<CMSListResponse<CMSPage>>('/cms/pages'),
  getPage: (id: number) => api.get<CMSResponse<CMSPage>>(`/cms/pages/${id}`),
  createPage: (data: CMSPageInput) => api.post<CMSResponse<{ id: number }>>('/cms/pages', data),
  updatePage: (id: number, data: CMSPageInput) => api.put<CMSResponse<void>>(`/cms/pages/${id}`, data),
  deletePage: (id: number) => api.delete<CMSResponse<void>>(`/cms/pages/${id}`),

  // ===== HERO =====
  getHero: (pageId: number) => api.get<CMSResponse<CMSHero | null>>(`/cms/pages/${pageId}/hero`),
  updateHero: (pageId: number, data: CMSHeroInput) => api.put<CMSResponse<void>>(`/cms/pages/${pageId}/hero`, data),

  // ===== FEATURES =====
  getFeatures: (pageId: number) => api.get<CMSListResponse<CMSFeature>>(`/cms/pages/${pageId}/features`),
  createFeature: (pageId: number, data: CMSFeatureInput) => api.post<CMSResponse<{ id: number }>>(`/cms/pages/${pageId}/features`, data),
  updateFeature: (id: number, data: CMSFeatureInput) => api.put<CMSResponse<void>>(`/cms/features/${id}`, data),
  deleteFeature: (id: number) => api.delete<CMSResponse<void>>(`/cms/features/${id}`),
  reorderFeatures: (pageId: number, orders: { id: number; ordem: number }[]) =>
    api.put<CMSResponse<void>>(`/cms/pages/${pageId}/features/reorder`, { orders }),

  // ===== PLANOS/PREÇOS =====
  getPricing: (pageId: number) => api.get<CMSListResponse<CMSPlan>>(`/cms/pages/${pageId}/pricing`),
  createPlan: (pageId: number, data: CMSPlanInput) => api.post<CMSResponse<{ id: number }>>(`/cms/pages/${pageId}/pricing`, data),
  updatePlan: (id: number, data: CMSPlanInput) => api.put<CMSResponse<void>>(`/cms/pricing/${id}`, data),
  deletePlan: (id: number) => api.delete<CMSResponse<void>>(`/cms/pricing/${id}`),

  // ===== TESTEMUNHOS =====
  getTestimonials: () => api.get<CMSListResponse<CMSTestimonial>>('/cms/testimonials'),
  createTestimonial: (data: CMSTestimonialInput) => api.post<CMSResponse<{ id: number }>>('/cms/testimonials', data),
  updateTestimonial: (id: number, data: CMSTestimonialInput) => api.put<CMSResponse<void>>(`/cms/testimonials/${id}`, data),
  deleteTestimonial: (id: number) => api.delete<CMSResponse<void>>(`/cms/testimonials/${id}`),

  // ===== PARCEIROS =====
  getParceiros: () => api.get<CMSListResponse<CMSParceiro>>('/cms/parceiros'),
  createParceiro: (data: CMSParceiroInput) => api.post<CMSResponse<{ id: number }>>('/cms/parceiros', data),
  updateParceiro: (id: number, data: CMSParceiroInput) => api.put<CMSResponse<void>>(`/cms/parceiros/${id}`, data),
  deleteParceiro: (id: number) => api.delete<CMSResponse<void>>(`/cms/parceiros/${id}`),

  // ===== FAQ =====
  getFAQ: (pageId?: number) => api.get<CMSListResponse<CMSFAQ>>('/cms/faq', { params: pageId ? { page_id: pageId } : {} }),
  createFAQ: (data: CMSFAQInput) => api.post<CMSResponse<{ id: number }>>('/cms/faq', data),
  updateFAQ: (id: number, data: CMSFAQInput) => api.put<CMSResponse<void>>(`/cms/faq/${id}`, data),
  deleteFAQ: (id: number) => api.delete<CMSResponse<void>>(`/cms/faq/${id}`),

  // ===== CTAs =====
  getCTAs: (pageId: number) => api.get<CMSListResponse<CMSCTA>>(`/cms/pages/${pageId}/ctas`),
  createCTA: (pageId: number, data: CMSCTAInput) => api.post<CMSResponse<{ id: number }>>(`/cms/pages/${pageId}/ctas`, data),
  updateCTA: (id: number, data: CMSCTAInput) => api.put<CMSResponse<void>>(`/cms/ctas/${id}`, data),
  deleteCTA: (id: number) => api.delete<CMSResponse<void>>(`/cms/ctas/${id}`),

  // ===== BLOG - ARTIGOS =====
  getBlogPosts: (params?: { status?: string; categoria?: number; page?: number; limit?: number }) =>
    api.get<CMSListResponse<CMSBlogPost>>('/cms/blog/posts', { params }),
  getBlogPost: (id: number) => api.get<CMSResponse<CMSBlogPost>>(`/cms/blog/posts/${id}`),
  createBlogPost: (data: CMSBlogPostInput) => api.post<CMSResponse<{ id: number }>>('/cms/blog/posts', data),
  updateBlogPost: (id: number, data: CMSBlogPostInput) => api.put<CMSResponse<void>>(`/cms/blog/posts/${id}`, data),
  publishBlogPost: (id: number) => api.put<CMSResponse<void>>(`/cms/blog/posts/${id}/publish`),
  unpublishBlogPost: (id: number) => api.put<CMSResponse<void>>(`/cms/blog/posts/${id}/unpublish`),
  deleteBlogPost: (id: number) => api.delete<CMSResponse<void>>(`/cms/blog/posts/${id}`),

  // ===== BLOG - CATEGORIAS =====
  getBlogCategories: () => api.get<CMSListResponse<CMSBlogCategory>>('/cms/blog/categories'),
  createBlogCategory: (data: Partial<CMSBlogCategory>) => api.post<CMSResponse<{ id: number }>>('/cms/blog/categories', data),
  updateBlogCategory: (id: number, data: Partial<CMSBlogCategory>) => api.put<CMSResponse<void>>(`/cms/blog/categories/${id}`, data),
  deleteBlogCategory: (id: number) => api.delete<CMSResponse<void>>(`/cms/blog/categories/${id}`),

  // ===== BLOG - AUTORES =====
  getBlogAuthors: () => api.get<CMSListResponse<CMSBlogAuthor>>('/cms/blog/authors'),
  createBlogAuthor: (data: Partial<CMSBlogAuthor>) => api.post<CMSResponse<{ id: number }>>('/cms/blog/authors', data),
  updateBlogAuthor: (id: number, data: Partial<CMSBlogAuthor>) => api.put<CMSResponse<void>>(`/cms/blog/authors/${id}`, data),
  deleteBlogAuthor: (id: number) => api.delete<CMSResponse<void>>(`/cms/blog/authors/${id}`),

  // ===== FOOTER =====
  getFooter: () => api.get<CMSResponse<CMSFooter>>('/cms/footer'),
  updateFooter: (data: { descricao_empresa?: string; copyright_texto?: string }) => api.put<CMSResponse<void>>('/cms/footer', data),
  createFooterColumn: (data: { titulo: string; ordem?: number }) => api.post<CMSResponse<{ id: number }>>('/cms/footer/columns', data),
  updateFooterColumn: (id: number, data: { titulo: string; ordem?: number }) => api.put<CMSResponse<void>>(`/cms/footer/columns/${id}`, data),
  deleteFooterColumn: (id: number) => api.delete<CMSResponse<void>>(`/cms/footer/columns/${id}`),
  createFooterLink: (data: Partial<CMSFooterLink>) => api.post<CMSResponse<{ id: number }>>('/cms/footer/links', data),
  updateFooterLink: (id: number, data: Partial<CMSFooterLink>) => api.put<CMSResponse<void>>(`/cms/footer/links/${id}`, data),
  deleteFooterLink: (id: number) => api.delete<CMSResponse<void>>(`/cms/footer/links/${id}`),

  // ===== FOOTER - REDES SOCIAIS =====
  createFooterSocial: (data: Partial<CMSFooterSocial>) => api.post<CMSResponse<{ id: number }>>('/cms/footer/social', data),
  updateFooterSocial: (id: number, data: Partial<CMSFooterSocial>) => api.put<CMSResponse<void>>(`/cms/footer/social/${id}`, data),
  deleteFooterSocial: (id: number) => api.delete<CMSResponse<void>>(`/cms/footer/social/${id}`),

  // ===== CONFIG =====
  getConfig: () => api.get<CMSListResponse<CMSConfig>>('/cms/config'),
  updateConfig: (key: string, data: { valor?: string; valor_en?: string; valor_fr?: string; tipo?: string; descricao?: string }) =>
    api.put<CMSResponse<void>>(`/cms/config/${key}`, data),

  // ===== TRANSLATIONS =====
  getTranslations: (table: string) =>
    api.get<{ success: boolean; data: any[]; fields: string[] }>(`/cms/translations/${table}`),
  getTranslation: (table: string, id: number) =>
    api.get<{ success: boolean; data: any; fields: string[] }>(`/cms/translations/${table}/${id}`),
  updateTranslation: (table: string, id: number, data: Record<string, string>) =>
    api.put<CMSResponse<void>>(`/cms/translations/${table}/${id}`, data),

  // ===== MEDIA =====
  getMedia: (params?: { pasta?: string; tipo?: string }) => {
    const query = new URLSearchParams();
    if (params?.pasta) query.append('pasta', params.pasta);
    if (params?.tipo) query.append('tipo', params.tipo);
    return api.get<CMSListResponse<CMSMedia>>(`/cms/media${query.toString() ? '?' + query.toString() : ''}`);
  },
  uploadMedia: (file: File, pasta?: string, altText?: string, nome?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    if (pasta) formData.append('pasta', pasta);
    if (altText) formData.append('alt_text', altText);
    if (nome) formData.append('nome', nome);
    return api.post<CMSResponse<CMSMedia>>('/cms/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  // Upload via base64/JSON — fiável no Cloud Functions (o multipart não é)
  uploadMediaBase64: (file: File, pasta?: string, nome?: string) =>
    new Promise<{ data: CMSResponse<CMSMedia> }>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const res = await api.post<CMSResponse<CMSMedia>>('/cms/media/upload-base64', {
            filename: file.name,
            contentType: file.type,
            data: reader.result, // data URL (data:<mime>;base64,....)
            pasta,
            nome,
          });
          resolve(res);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error('Falha ao ler o ficheiro'));
      reader.readAsDataURL(file);
    }),
  updateMedia: (id: number, data: { nome?: string; alt_text?: string; pasta?: string }) =>
    api.put<CMSResponse<void>>(`/cms/media/${id}`, data),
  deleteMedia: (id: number) => api.delete<CMSResponse<void>>(`/cms/media/${id}`),
};

export default cmsService;
